export { default as SideBar } from './SideBar.vue'
export { default as AppMain } from "./AppMain.vue";
export { default as HeaderBar } from "./HeaderBar.vue";


// WEBPACK FOOTER //
// ./src/views/homenew/components/index.ts